import { useState } from "react"
import { Form, Input, Button, message } from "antd"
import { MailOutlined } from "@ant-design/icons"
import { useNavigate } from "react-router"

export default function LoginForm() {
  const [form] = Form.useForm()
  const [loading, setLoading] = useState(false)
  const [step, setStep] = useState(1)
  const navigate = useNavigate()

  const sendLink = async (values) => {
    setLoading(true)
    try {
      // const output = await fetch("/api/auth/passwordless", {
      //   method: "POST",
      //   headers: {
      //     "Content-Type": "application/json",
      //   },
      //   body: JSON.stringify({
      //     email: values.email,
      //   }),
      // })

      // Mock
      const output = { ok: true, status: 200 }

      if (!output.ok) {
        message.error(
          "Failed to send login link. Please contact administrator.",
        )
        return
      }
      message.success(
        "Email sent! Please check your email for the verification code.",
      )
    } catch (err) {
      message.error("Failed to send login link")
    } finally {
      setLoading(false)
      setStep(2)
    }
  }

  const verifyCode = async (values) => {
    setLoading(true)
    try {
      // const output = await fetch("/api/auth/passwordless", {
      //   method: "POST",
      //   headers: {
      //     "Content-Type": "application/json",
      //   },
      //   body: JSON.stringify({
      //     email: values.email,
      //   }),
      // })

      // Mock
      const output = { ok: true, status: 200 }

      if (!output.ok) {
        message.error(
          "Failed to send login link. Please contact administrator.",
        )
        return
      }
      message.success("Successfully logged in")
    } catch (err) {
      message.error("Failed to send login link")
    } finally {
      setLoading(false)
      navigate("/partners-area")
      window.scrollTo(0, 0)
    }
  }

  return (
    <>
      {step === 1 && (
        <Form
          form={form}
          layout="vertical"
          onFinish={sendLink}
          initialValues={{ email: "abc@abc.com" }}
        >
          <Form.Item
            label="Email"
            name="email"
            initialValue={{ email: "abc@abc.com" }}
            rules={[
              { required: true, message: "Email is required" },
              { type: "email", message: "Enter a valid email" },
            ]}
          >
            <Input placeholder="you@example.com" />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" loading={loading} block>
              Send Email Verification Code
            </Button>
          </Form.Item>
        </Form>
      )}

      {step === 2 && (
        <Form
          form={form}
          layout="vertical"
          onFinish={verifyCode}
          initialValue={{ code: "123 456" }}
        >
          <Form.Item
            label="Verification Code"
            name="code"
            initialValue={"123 456"}
            rules={[
              { required: true, message: "Please enter the verification code" },
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" loading={loading} block>
              Login
            </Button>
          </Form.Item>
        </Form>
      )}
    </>
  )
}
